import { render } from "./HomeBanner.vue?vue&type=template&id=29bd0ed8&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"

import "./HomeBanner.vue?vue&type=style&index=0&id=29bd0ed8&lang=less&scoped=true"

import exportComponent from "C:\\project\\famous-build-en\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bd0ed8"]])

export default __exports__